import { render, staticRenderFns } from "./Form.vue?vue&type=template&id=45db7a2a&scoped=true"
import script from "./Form.vue?vue&type=script&lang=js"
export * from "./Form.vue?vue&type=script&lang=js"
import style0 from "./Form.vue?vue&type=style&index=0&id=45db7a2a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45db7a2a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/build_997aa59e/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45db7a2a')) {
      api.createRecord('45db7a2a', component.options)
    } else {
      api.reload('45db7a2a', component.options)
    }
    module.hot.accept("./Form.vue?vue&type=template&id=45db7a2a&scoped=true", function () {
      api.rerender('45db7a2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/investments/firm-model-manager/Form.vue"
export default component.exports